import React, { Component } from 'react';
import { Table } from 'antd';
const { Column, ColumnGroup } = Table;
import { observer, inject } from 'mobx-react';
import { BToM } from '../../lib/lib';

@inject('trafficReportStore')
@observer
class TrafficReportTable extends Component {
  render() {
    const { dateArr, data, onChangePage, page_num } = this.props;
    const { trafficDateTotal } = this.props.trafficReportStore;
    let formData = [];
    (data || []).forEach((item, index) => {
      let dateObj = {};
      (item.net_list || []).forEach((a, ind) => {
        dateObj['data_traffic' + ind] = BToM(a.data_traffic);
        dateObj['ethernet_traffic' + ind] = BToM(a.ethernet_traffic);
        dateObj['third_party_traffic' + ind] = BToM(a.third_party_traffic);
      });
      formData.push(
        Object.assign(
          { ...dateObj },
          {
            key: index + 1,
            device_id: item.device_id,
            data_traffic_total: BToM(item.data_traffic_total),
            ethernet_traffic_total: BToM(item.ethernet_traffic_total),
            third_party_traffic_total: BToM(item.third_party_traffic_total),
            last_update_time: item.last_update_time || '--'
          }
        )
      );
    });
    let columns = [
      {
        title: '设备编号',
        dataIndex: 'device_id',
        key: 'device_id',
        width: 200,
        fixed: 'left',
        className: 'columText'
      },
      {
        title: '总计',
        children: [
          {
            title: '移动流量(M)',
            dataIndex: 'data_traffic_total',
            key: 'data_traffic_total',
            className: 'columText',
            width: 150
          },
          {
            title: '宽带流量(M)',
            dataIndex: 'ethernet_traffic_total',
            key: 'ethernet_traffic_total',
            className: 'columText',
            width: 150
          },
          {
            title: '运营商统计流量(M)',
            dataIndex: 'third_party_traffic_total',
            key: 'third_party_traffic_total',
            className: 'columText',
            width: 150
          }
        ]
      }
    ];
    (dateArr || []).map((item, index) => {
      columns.push({
        title: item,
        children: [
          {
            title: '移动流量(M)',
            dataIndex: `data_traffic${index}`,
            key: `data_traffic${index}`,
            className: 'columText',
            width: 150
          },
          {
            title: '宽带流量(M)',
            dataIndex: `ethernet_traffic${index}`,
            key: `ethernet_traffic${index}`,
            className: 'columText',
            width: 150
          },
          {
            title: '运营商统计流量(M)',
            dataIndex: `third_party_traffic${index}`,
            key: `third_party_traffic${index}`,
            className: 'columText',
            width: 150
          }
        ]
      });
    });
    columns.push({
      title: '最后更新时间',
      dataIndex: 'last_update_time',
      key: 'last_update_time',
      width: 150,
      className: 'columText'
    });
    return (
      <div>
        <Table
          pagination={{
            pageSize: 20,
            total: trafficDateTotal,
            onChange: onChangePage,
            current: page_num
          }}
          dataSource={formData}
          bordered
          scroll={{ x: (columns.length - 1) * 440 }}
          columns={columns}
        />
      </div>
    );
  }
}

export default TrafficReportTable;



// WEBPACK FOOTER //
// ./src/components/TrafficReport/TrafficReportTable.js